import locations from './locations.json'

export default locations
  .sort( ( a, b ) => ( a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1 ) )
